import './ToDoList.css';

import { Box } from '@material-ui/core';
import { Lender, Merchant, MerchantData, MerchantStructure } from '@nemuru-eng/js-api-client';
import React, { useState } from 'react';

import { CustomPaper } from '@/components/shared/components/CustomPaper';
import { FlexColumn } from '@/components/shared/components/FlexColumn';
import { FlexRow } from '@/components/shared/components/FlexRow';
import { Icon } from '@/components/shared/components/Icon';
import { StyledAccordion } from '@/components/shared/components/StyledAccordion';

import { useCustomTheme } from '../../../../../hooks/useCustomTheme';
import { useScreen } from '../../../../../hooks/useScreen';
import { Font } from '../../../../shared/components/Font';
import { Text } from '../../../../shared/components/Text';

export const ToDoList: React.FC<ToDoList> = ({ merchant, merchantData, merchantStructure, merchantLenders = [] }) => {
  const { palette } = useCustomTheme();
  const { lg } = useScreen();

  const [expanded, setExpanded] = useState(false);

  const toDos: ToDo[] = [
    {
      textId: 'ADD_LEGAL_ADDRESS',
      isCompleted: !!merchantData?.legalAddress,
    },
    {
      textId: 'ADD_CASH_IN_CASH_OUT_METHOD',
      isCompleted: !!merchant?.cashInCashOutMethodIds,
    },
    {
      textId: 'ADD_BRANDING_INFROMATION',
      isCompleted: !!merchantData?.brandInformation,
    },
    {
      textId: 'APPROVE_BY_COMMERCIAL',
      isCompleted: merchant.approvalStatus.isApprovedByCommercial,
    },
    {
      textId: 'APPROVE_BY_RISK',
      isCompleted: merchant.approvalStatus.isApprovedByRisk,
    },
    {
      textId: 'ADD_MERCHANT_IN_LENDER_CONTEXT',
      isCompleted: !!merchantLenders?.length,
    },
    {
      textId: 'ADD_MERCHANT_STRUCTURE',
      isCompleted: !!merchantStructure?.merchant.channels.length,
    },
  ];

  if (!toDos.some((toDo) => !toDo.isCompleted)) {
    return null;
  }

  return (
    <Box position="absolute" top={0} right={0} height="fit-content" zIndex={1000} width={lg ? '324px' : '100%'}>
      <StyledAccordion.Accordion expanded={expanded} onChange={() => setExpanded(!expanded)}>
        <StyledAccordion.AccordionSummary expandIcon={<Icon>expand_more</Icon>}>
          <FlexRow justifyContent="flex-end" width="100%">
            <Font variant={'body2'} color={'textSecondary'}>
              <strong>
                <Text tId={'PENDING_TODO_ACTIONS'} /> ({toDos.filter((toDo) => !toDo.isCompleted).length})
              </strong>
            </Font>
          </FlexRow>
        </StyledAccordion.AccordionSummary>
        <StyledAccordion.AccordionDetails>
          <CustomPaper fill="paper">
            <FlexColumn>
              {toDos.map((toDo, key) => (
                <Box key={`to-do-${key}`} className={'to-do'} mb={1}>
                  <Box
                    className={'check'}
                    bgcolor={toDo.isCompleted ? palette.success.main : 'transparent'}
                    borderColor={toDo.isCompleted ? 'transparent' : palette.grey[200]}
                  >
                    {toDo.isCompleted && (
                      <i className={'material-icons-outlined'} style={{ color: palette.success.contrastText }}>
                        check
                      </i>
                    )}
                  </Box>
                  <Font
                    variant={'body2'}
                    color={'textSecondary'}
                    style={{ textDecoration: toDo.isCompleted ? 'line-through' : 'inherit' }}
                  >
                    <Text tId={toDo.textId} />
                  </Font>
                </Box>
              ))}
            </FlexColumn>
          </CustomPaper>
        </StyledAccordion.AccordionDetails>
      </StyledAccordion.Accordion>
    </Box>
  );
};

interface ToDoList {
  merchant: Merchant;
  merchantLenders: Lender[];
  merchantData?: MerchantData;
  merchantStructure?: MerchantStructure;
}

interface ToDo {
  textId: string;
  isCompleted: boolean;
}
